<template>
    <v-dialog v-model="openMode" max-width="600px" persistent>
        <v-card>
            <v-card-title class="text-h5">{{ formTitle }}</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="editedPortin.phone" label="מספר נייד*" outlined dense
                                :rules="[rules.required, rules.phoneFormat]" maxlength="10">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="editedPortin.tempNumber" label="מספר זמני*" outlined dense
                                :rules="[rules.required, rules.phoneFormat]" maxlength="10">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="editedPortin.simNumber" label="מספר סים" outlined dense
                                maxlength="20">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="editedPortin.statusOriginal" :items="statusOptions" label="סטטוס*" outlined
                                dense :rules="[rules.required]">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="editedPortin.packageLoadedOriginal" :items="packageLoadedOptions"
                                label="סטטוס חבילה*" outlined dense :rules="[rules.required]">
                            </v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-row v-if="progressShow">
                <v-col class="d-flex justify-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#6a6aec" text @click="closeDialog">ביטול</v-btn>
                <v-btn color="#6a6aec" text @click="savePortin" :disabled="!isFormValid">שמור</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'

export default {
    props: {
        itemToEdit: Object,
        formTitle: String,
        value: { type: Boolean, default: false },
    },
    data: () => ({
        progressShow: false,
        editedPortin: {},
        statusOptions: [
            { text: 'ממתין', value: 'pending' },
            { text: 'ממתין לאישור', value: 'await_auth' },
            { text: 'ממתין לניוד', value: 'await_portin' },
            { text: 'הצליח', value: 'success' },
            { text: 'נכשל', value: 'failed' },
        ],
        packageLoadedOptions: [
            { text: 'ממתין', value: 'pending' },
            { text: 'הצליח', value: 'success' },
            { text: 'נכשל', value: 'failed' },
        ],
        rules: {
            required: value => !!value || 'שדה חובה',
            phoneFormat: value => {
                if (!value) return true;
                const pattern = /^0\d{9}$/;
                return pattern.test(value) || 'מספר נייד חייב להיות בפורמט: 05XXXXXXXX (10 ספרות שמתחילות ב-0)';
            }
        }
    }),

    watch: {
        itemToEdit: {
            handler(newVal) {
                if (newVal) {
                    this.editedPortin = { ...newVal };
                }
            },
            immediate: true,
            deep: true
        }
    },

    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
        isFormValid() {
            return (
                this.editedPortin.phone &&
                this.editedPortin.tempNumber &&
                this.editedPortin.statusOriginal &&
                this.editedPortin.packageLoadedOriginal &&
                this.rules.phoneFormat(this.editedPortin.phone) === true &&
                this.rules.phoneFormat(this.editedPortin.tempNumber) === true
            );
        }
    },

    methods: {
        async savePortin() {
            if (!this.isFormValid) {
                return;
            }

            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");

                // הכנת הנתונים לשליחה - רק השדות שניתן לעריכה
                const portinData = {
                    id: this.editedPortin.id,
                    phone: this.editedPortin.phone,
                    tempNumber: this.editedPortin.tempNumber,
                    simNumber: this.editedPortin.simNumber || null,
                    status: this.editedPortin.statusOriginal,
                    packageLoaded: this.editedPortin.packageLoadedOriginal,
                };

                const portinJSON = JSON.stringify(portinData);

                let api = process.env.VUE_APP_BASE_URL + "/admin/update_portin";
                const res = await fetch(api, ApiServices.requestOptions("PUT", portinJSON, token));
                this.progressShow = false;

                if (res.status === 400) {
                    this.$emit("portinEdited", "", "תקלה בעדכון ניוד", "red");
                } else if (res.status === 403) {
                    const jsonObject = await res.json();
                    this.$emit("portinEdited", "", "שגיאה בעדכון ניוד: " + jsonObject.message, "red");
                    this.openMode = false;
                } else if (res.status === 200) {
                    const updatedPortin = await res.json();
                    this.$emit("portinEdited", updatedPortin, "הניוד עודכן בהצלחה!", "green");
                    this.openMode = false;
                }
            } catch (error) {
                this.progressShow = false;
                this.$emit("portinEdited", "", "תקלה בעדכון ניוד: " + error, "red");
            }
        },

        closeDialog() {
            this.openMode = false;
        }
    },
}
</script>

<style scoped>
.v-card__title {
    background-color: #f5f5f5;
}
</style>